import en from './en';
import ar from './ar';
import {Locales} from "@shared/models/locales.model";

export default {
  modulePrefix: 'shared',
  phrasesPerLang: {
    en,
    ar,
  },
} as Locales;
